import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxFlex = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    gap: 1.25rem;
    display: flex;
    justify-content: space-between;
    
    .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input {
        max-width: 6.93rem;
    }

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      
   }
`);

export const LinkExtermal = styled('a')(`
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1rem;
        height: 1.2rem;
    }
`);
